import http from '../utils/api'

export const getLogsList = (pagination, filters, sorter, searchTerm) =>
  http.post('/salesforce/logs', {
    pagination,
    filters,
    sorter,
    searchTerm,
  })
